<template src="./Bar.html"></template>
<style src="./Bar.css"></style>

<script>
export default {
  props: {
    title: { type: String },
    series: { type: Array },
    categories: { type: Array },
    xAsisType: { type: String }, // xAsisType = text, datetime
    dataPointSelection: { type: Function },
    width: { type: Number },
    height: { type: Number },
    horizontal: {type: Boolean},
  },
  data() {
    const self = this;

    return {
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        title: {
          text: self.title
        },
        colors: ["#2A5377", "#88C658", "#53856a"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: this.horizontal
          }
        },
        xaxis: {
          type: this.xAsisType,
          categories: this.categories
        },
        legend: {
          position: "right",
          offsetY: 40
        },
        fill: {
          opacity: 1
        },
        chart: {
          events: {
            dataPointSelection: function(event, chartContext, config) {
              self.dataPointSelection(event, chartContext, config);
            }
          }
        }
      }
    };
  }
};
</script>